import { Node as ProseNode } from 'prosemirror-model'
import { isTableCell } from '.'
import { isEmptyNode } from '../isEmptyNode'

export const isTableEmpty = (table: ProseNode) => {
  let tableEmpty = true
  table.descendants((node, pos) => {
    if (isTableCell(node) && !isEmptyNode(node)) tableEmpty = false
  })
  return tableEmpty
}
